import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import { DialogContent } from '@material-ui/core'
import { Pannellum } from 'pannellum-react'
import useMediaPath from 'hooks/useMediaPath'

const Details = ({ env, setOpen, open }) => {
  const mediaPath = useMediaPath()
  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg" fullWidth>
      <DialogTitle>{env.name}</DialogTitle>
      <DialogContent>
        <Pannellum
          width="100%"
          height="500px"
          image={mediaPath(env.panoThumb)}
          pitch={10}
          yaw={180}
          hfov={110}
          autoLoad
          onLoad={() => {
            console.log('panorama loaded')
          }}
        />
      </DialogContent>
    </Dialog>
  )
}

export default Details
